import * as React from 'react'
import {StickyContainer} from "react-sticky";
import TopBar from "./top-bar/top-bar";
import HeaderMenu from "./header/header";
import HeaderPositionerWrapper from "./header/header-positioner";
import Footer from "./footer/footer";

import '../assets/index.scss';

interface DefaultLayoutProps extends React.HTMLProps<HTMLDivElement> {
  location: {
    pathname: string
  }
  children: any
}

interface DefaultLayoutState {
  headerMenuIsSticky: boolean
}

class DefaultLayout extends React.PureComponent<DefaultLayoutProps, DefaultLayoutState> {

  constructor(props: DefaultLayoutProps) {
    super(props);
    this.state = {
      headerMenuIsSticky: false
    };
    this.updateHeaderMenuState = this.updateHeaderMenuState.bind(this);
  }

  updateHeaderMenuState(isSticky: boolean, stickyProps: ReactStickyPropsV6) {
    this.setState({headerMenuIsSticky: isSticky});
  }

  render() {
    const {location,children} = this.props;
    const {headerMenuIsSticky} = this.state;
    return (
      <StickyContainer className="index-layout-container">
        <TopBar/>
        <HeaderMenu
          pathName={location.pathname}
          headerMenuIsSticky={headerMenuIsSticky}
          updateHeaderMenuState={this.updateHeaderMenuState}
        />
        <HeaderPositionerWrapper
          headerMenuIsSticky={headerMenuIsSticky}
        />
        {children()}
        <Footer/>
      </StickyContainer>
    )
  }

}

export default DefaultLayout



// WEBPACK FOOTER //
// ./src/layouts/index.tsx